import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NativeInteractiveElementnutmif7l5rxf as NativeInteractiveElement } from '../InteractiveElement.commonHtml.mjs';
import { ClickableSemantic_getInstance29tidgppnw5x2 as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import {
  radioDriverValuersbiyzmihqhw as radioDriverValue,
  radioDriverActions3r5vrcuo9p8fc as radioDriverActions,
} from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function RadioButton$checked$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  var tmp = $this$vprop.attributes_1.native_1.checked;
  return ((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true;
}
function RadioButton$checked$lambda_0($this$vprop, value) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  $this$vprop.attributes_1.native_1.checked = value;
  return Unit_instance;
}
var RadioButtonClass;
function RadioButton() {
  if (RadioButtonClass === VOID) {
    class $ extends NativeInteractiveElement() {
      constructor(context) {
        super(context);
        this.set_themeChoice_py59um_k$(this.get_themeChoice_22tyn3_k$().plus_duvq05_k$(ClickableSemantic_getInstance()));
        this.native_1.tag_1 = 'input';
        // Inline function 'com.lightningkite.kiteui.views.type' call
        this.native_1.attributes_1.native_1.type = 'radio';
        this.native_1.classes_1.add_utx5q5_k$('radio');
        this.native_1.classes_1.add_utx5q5_k$('checkResponsive');
        this.native_1.classes_1.add_utx5q5_k$('clickable');
        var tmp = this;
        var tmp_0 = this.native_1;
        var tmp_1 = RadioButton$checked$lambda;
        tmp.checked_1 = vprop(tmp_0, 'input', tmp_1, RadioButton$checked$lambda_0);
      }
      get_underlyingNativeElement_vngz33_k$() {
        return this;
      }
      get_driverValue_yh5neo_k$() {
        return radioDriverValue(this);
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), radioDriverActions(this));
      }
    }
    initMetadataForClass($, 'RadioButton');
    RadioButtonClass = $;
  }
  return RadioButtonClass;
}
//region block: exports
export {
  RadioButton as RadioButton1rpamcjl5aybg,
};
//endregion

//# sourceMappingURL=RadioButton.commonHtml.mjs.map
